import { render, staticRenderFns } from "./InfoAziendaliCard.vue?vue&type=template&id=5b60238e&scoped=true"
import script from "./InfoAziendaliCard.vue?vue&type=script&lang=ts"
export * from "./InfoAziendaliCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b60238e",
  null
  
)

export default component.exports